// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fee-month-projection {
  --fmp-ink: #1f1b2e;
  --fmp-muted: #55515f;
  --fmp-soft: #6f7588;
  --fmp-line: rgba(31, 27, 46, 0.12);
  --fmp-surface: #ffffff;
  --fmp-panel: #f4f4f6;

  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  color: var(--fmp-ink);
}

.fee-month-projection__head {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.fee-month-projection__title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fmp-soft);
}

.fee-month-projection__lede {
  margin: 0;
  font-size: 0.88rem;
  color: var(--fmp-muted);
}

.fee-month-projection__totals {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
}

.fee-month-projection__total {
  padding: 0.7rem 0.8rem;
  border-radius: 10px;
  background: var(--fmp-surface);
  border: 1px solid var(--fmp-line);
}

.fee-month-projection__total span {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fmp-soft);
}

.fee-month-projection__total strong {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--fmp-ink);
}

.fee-month-projection__total--due {
  border-color: rgba(180, 70, 70, 0.35);
}

.fee-month-projection__total--due span,
.fee-month-projection__total--due strong {
  color: #8a3030;
}

.fee-month-projection__total--paid strong {
  color: #1f5a42;
}

.fee-month-projection__groups {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fee-month-projection__group {
  border: 1px solid var(--fmp-line);
  border-radius: 12px;
  background: var(--fmp-surface);
  overflow: hidden;
}

.fee-month-projection__group-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.45rem 1rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--fmp-line);
  background: var(--fmp-panel);
}

.fee-month-projection__group-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 750;
  color: var(--fmp-ink);
}

.fee-month-projection__group-totals {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--fmp-muted);
}

.fee-month-projection__group-due {
  color: #8a3030;
}

.fee-month-projection__table-wrap {
  overflow-x: auto;
  background: var(--fmp-surface);
}

.fee-month-projection__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 420px;
}

.fee-month-projection__table th,
.fee-month-projection__table td {
  padding: 0.7rem 0.85rem;
  text-align: left;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(31, 27, 46, 0.08);
}

.fee-month-projection__table th {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fmp-soft);
  background: #fafafa;
}

.fee-month-projection__group .fee-month-projection__table tr:last-child td {
  border-bottom: none;
}

.fee-month-projection__status {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.fee-month-projection__status--paid {
  background: #bff1db;
  color: #1f3d32;
}

.fee-month-projection__status--partial {
  background: #f9e1be;
  color: #5a4020;
}

.fee-month-projection__status--unpaid {
  background: #f2c4c4;
  color: #5a3030;
}

.fee-month-projection__status--waived {
  background: #d5d1fd;
  color: #3a3560;
}

.fee-month-projection--compact .fee-month-projection__totals {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 640px) {
  .fee-month-projection__totals {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeeMonthProjection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;;EAEpB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".fee-month-projection {\n  --fmp-ink: #1f1b2e;\n  --fmp-muted: #55515f;\n  --fmp-soft: #6f7588;\n  --fmp-line: rgba(31, 27, 46, 0.12);\n  --fmp-surface: #ffffff;\n  --fmp-panel: #f4f4f6;\n\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  color: var(--fmp-ink);\n}\n\n.fee-month-projection__head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.fee-month-projection__title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--fmp-soft);\n}\n\n.fee-month-projection__lede {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--fmp-muted);\n}\n\n.fee-month-projection__totals {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.55rem;\n}\n\n.fee-month-projection__total {\n  padding: 0.7rem 0.8rem;\n  border-radius: 10px;\n  background: var(--fmp-surface);\n  border: 1px solid var(--fmp-line);\n}\n\n.fee-month-projection__total span {\n  display: block;\n  margin-bottom: 0.2rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fmp-soft);\n}\n\n.fee-month-projection__total strong {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: var(--fmp-ink);\n}\n\n.fee-month-projection__total--due {\n  border-color: rgba(180, 70, 70, 0.35);\n}\n\n.fee-month-projection__total--due span,\n.fee-month-projection__total--due strong {\n  color: #8a3030;\n}\n\n.fee-month-projection__total--paid strong {\n  color: #1f5a42;\n}\n\n.fee-month-projection__groups {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fee-month-projection__group {\n  border: 1px solid var(--fmp-line);\n  border-radius: 12px;\n  background: var(--fmp-surface);\n  overflow: hidden;\n}\n\n.fee-month-projection__group-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.45rem 1rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--fmp-line);\n  background: var(--fmp-panel);\n}\n\n.fee-month-projection__group-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 750;\n  color: var(--fmp-ink);\n}\n\n.fee-month-projection__group-totals {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem 0.9rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--fmp-muted);\n}\n\n.fee-month-projection__group-due {\n  color: #8a3030;\n}\n\n.fee-month-projection__table-wrap {\n  overflow-x: auto;\n  background: var(--fmp-surface);\n}\n\n.fee-month-projection__table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 420px;\n}\n\n.fee-month-projection__table th,\n.fee-month-projection__table td {\n  padding: 0.7rem 0.85rem;\n  text-align: left;\n  font-size: 0.9rem;\n  border-bottom: 1px solid rgba(31, 27, 46, 0.08);\n}\n\n.fee-month-projection__table th {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--fmp-soft);\n  background: #fafafa;\n}\n\n.fee-month-projection__group .fee-month-projection__table tr:last-child td {\n  border-bottom: none;\n}\n\n.fee-month-projection__status {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.fee-month-projection__status--paid {\n  background: #bff1db;\n  color: #1f3d32;\n}\n\n.fee-month-projection__status--partial {\n  background: #f9e1be;\n  color: #5a4020;\n}\n\n.fee-month-projection__status--unpaid {\n  background: #f2c4c4;\n  color: #5a3030;\n}\n\n.fee-month-projection__status--waived {\n  background: #d5d1fd;\n  color: #3a3560;\n}\n\n.fee-month-projection--compact .fee-month-projection__totals {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 640px) {\n  .fee-month-projection__totals {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
